import { render, staticRenderFns } from "./ConsignacaoHistorico.vue?vue&type=template&id=aa188b7c&"
import script from "./ConsignacaoHistorico.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports